export default "__VITE_ASSET__iBVXuygk__"